<template>
    <div v-if="columnCopy.length > 0" class="setting-column">
        <el-table :data="columnCopy" row-key="label" default-expand-all size="small" ref="settingRef">
            <el-table-column prop="label" label="名称" width="120px" show-overflow-tooltip></el-table-column>
            <el-table-column>
        <span class="move_b">
          <el-tag class="move" style="cursor: move"><el-icon-d-caret style="width: 1em; height: 1em"/></el-tag>
        </span>
            </el-table-column>
            <el-table-column prop="hide" label="显示">
                <template #default="{ row }">
                    <el-switch v-model="row.hide" :active-value="false" :inactive-value="true"></el-switch>
                </template>
            </el-table-column>

            <el-table-column prop="width" label="宽度">
                <template #default="{ row }">
                    <el-input v-model="row.width" placeholder="auto" size="small"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="sortable" label="排序">
                <template #default="{ row }">
                    <el-switch v-model="row.sortable"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="fixed" label="固定">
                <template #default="{ row }">
                    <el-switch v-model="row.fixed"></el-switch>
                </template>
            </el-table-column>
            <template #empty></template>
        </el-table>
        <div class="setting-column__bottom">
            <el-button @click="resetColumn">重置</el-button>
            <el-button @click="$emit('save-setting',columnCopy)" type="primary">保存</el-button>
        </div>
    </div>
    <div v-else>
        <el-empty description="暂无可配置的列" :image-size="80"></el-empty>
    </div>
</template>

<script>
import {onMounted, ref} from 'vue'
import Sortable from 'sortablejs'

export default {
    components: {
        Sortable,
    },
    props: {
        columns: {type: Array, default: () => []},
    },
    setup(props) {
        const settingRef = ref()
        let columnCopy = ref([])
        onMounted(() => {
            if (props.columns.length === 0) {
                return
            }
            columnCopy.value = JSON.parse(JSON.stringify(props.columns))

            setTimeout(() => {
                const tbody = settingRef.value.$el.querySelector(
                    '.el-table__body-wrapper tbody'
                )
                Sortable.create(tbody, {
                    handle: '.move',
                    animation: 300,
                    ghostClass: 'ghost',
                    onEnd({newIndex, oldIndex}) {
                        const tableData = columnCopy.value
                        const currRow = tableData.splice(oldIndex, 1)[0]
                        tableData.splice(newIndex, 0, currRow)
                    },
                })
            }, 200)

        })
        const resetColumn = () => {
            columnCopy.value = JSON.parse(JSON.stringify(props.columns))
        }
        return {
            settingRef,
            columnCopy,
            resetColumn
        }
    },
}
</script>

<style scoped>
.setting-column__title {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 15px;
}

.setting-column__title span {
    display: inline-block;
    font-weight: bold;
    color: #909399;
    font-size: 12px;
}

.setting-column__list {
    max-height: 314px;
    overflow: auto;
}

.setting-column__list li.ghost {
    opacity: 0.3;
}

.setting-column__bottom {
    border-top: 1px solid #ebeef5;
    padding-top: 15px;
    text-align: right;
}

.dark .setting-column__title {
    border-color: var(--el-border-color-light);
}

.dark .setting-column__bottom {
    border-color: var(--el-border-color-light);
}
</style>
